module.exports = "/_next/static/images/CollectionAPI@2x-7ea5ae124324f6a8811dddc18dd5eb4b.png";